import Vue from 'vue';

Vue.filter('length', (list = []) => {
	return list && !list.length;
});



// WEBPACK FOOTER //
// ./src/filters/length.js